import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './choosedates.scss'

// Actions
import { getOrderSimple, saveOrder } from '../../../../actions/orders'

// import components
import Modal from '../../../components/Modal'

// Utils
import { translation } from '../../../../utils/helpers'
import { renderFullDate } from '../../../../utils/time'

// Elements
import Button from '../../../elements/button'
import PanelHeader from '../../../elements/panelHeader'
// import LabelWrapper from '../../../elements/labelWrapper'
import Inline from '../../../elements/inline'
import Label from '../../../elements/label'
import Divider from '../../../elements/divider'

import { ModalIcons } from '../../../elements/icons'

class ChooseDatesModal extends Component {
  constructor (props) {
    super(props)

    this.state = {
      overflowHidden: false,
      mainOrder: null,
      orders: [],
      chosenTransport: 0,
      saving: false
    }

    this.changeDates = this.changeDates.bind(this)
    this.done = this.done.bind(this)
  }

  componentDidMount () {
    const { getOrderSimple, mainOrderId, orderIds } = this.props

    let promises = [
      getOrderSimple(mainOrderId),
      ...orderIds.map(id => getOrderSimple(id))
    ]

    Promise.all(promises).then(res => {
      const mainOrder = res[0].data
      const orders = res.reduce((orders, r, i) => {
        return i !== 0
          ? [...orders, r.data]
          : orders
      }, [])

      this.setState({
        mainOrder,
        orders
      })
    })
  }

  changeDates () {
    const { orders, mainOrder } = this.state
    const isBodyShop = mainOrder.IsBodyShopOrder

    this.setState({
      booking: true
    }, () => {
      const savings = orders.map(o => this.props.saveOrder({
        OrderId: o.Id,
        [isBodyShop ? 'BodyShopDelivery' : 'Delivery']: {
          IsDirty: true,
          Delivery: isBodyShop ? mainOrder.BodyShopDeliveryTime : mainOrder.Delivery,
          IsDeliveryDateChanged: true,
          DeliveryChangeReason: 4,
          ProductionDate: isBodyShop ? mainOrder.BodyShopProductionTime : mainOrder.ProductionDate,
          Pickup: isBodyShop ? mainOrder.BodyShopPickupTime : mainOrder.Pickup
        }
      }))

      Promise.all(savings)
        .then(res => {
          this.done()
        })
        .catch(() => {
          this.setState({
            booking: false
          })
          // Toastr
          window.toastr.error(translation('960'), translation('216'))
        })
    })
  }

  done () {
    this.props.complete()
  }

  renderView () {
    const { mainOrder, orders } = this.state

    const loadingSpinner = () => {
      return (
        <div className='chooseDates-loading'>
          <div className='animated-background'>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <span className='sr-only'>{translation('13382')}...</span>
          </div>
        </div>
      )
    }
    if (!mainOrder || orders.length === 0) return loadingSpinner()

    const renderOrder = (order, key) => {
      const { Id, Model, Pickup, BodyShopPickupTime, ProductionDate, BodyShopProductionTime, Delivery, BodyShopDeliveryTime } = order
      const isBodyShop = order.IsBodyShopOrder

      const notMain = key !== 'main'

      return (
        <div key={key}>
          {notMain && (
            <Label>{`${Model} (${Id})`}:</Label>
          )}
          <Inline block fillChildNum={[0]}>
            <span className='chooseDates__title'>{translation('14948')}:</span>
            <span className='chooseDates__date'>{renderFullDate(isBodyShop ? BodyShopPickupTime : Pickup, true)}</span>
          </Inline>
          <Inline block fillChildNum={[0]}>
            <span className='chooseDates__title'>{translation('13394')}:</span>
            <span className='chooseDates__date'>{renderFullDate(isBodyShop ? BodyShopProductionTime : ProductionDate, true)}</span>
          </Inline>
          <Inline block fillChildNum={[0]}>
            <span className='chooseDates__title'>{translation('14724')}:</span>
            <span className='chooseDates__date'>{renderFullDate(isBodyShop ? BodyShopDeliveryTime : Delivery, true)}</span>
          </Inline>
        </div>
      )
    }

    return (
      <div className='chooseDates'>
        <div>{translation('14728')}</div>
        <PanelHeader text={translation('14954') + ':'} />
        {orders.map(renderOrder)}
        <Divider size={1} noLine />
        <Button style='link' onClick={this.done} labelText={translation('14956')} />
        {/* <img src='/images/icons/Link-White.png' /> */}

        <PanelHeader text={translation('14955') + ':'} />
        {renderOrder(mainOrder, 'main')}
        <Divider size={1} noLine />
        <Button style='link' onClick={this.changeDates} labelText={translation('14957')} />
        {/* <img src='/images/icons/Link-White.png' /> */}
        {this.state.booking && loadingSpinner()}
      </div>
    )
  }

  render () {
    return (
      <div>
        <Modal
          header={translation('1848')}
          overflowHidden={this.state.overflowHidden}
          onClose={this.props.onClose}
          clickOutsideClose={false}
          icon={ModalIcons.Link}
          show={this.props.show}>
          {this.renderView()}
        </Modal>
      </div>
    )
  }
}

export default connect(null, {
  getOrderSimple,
  saveOrder
})(ChooseDatesModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/LinkOrdersModal/ChooseDatesModal/index.js